// Core
import styled from 'styled-components';

// Layout
import { Row } from '../Row';

// Plugins
import { hexToRgba } from '../../../plugins/general';

// Component
import { PaginationFooterProps } from './PaginationFooter.types';

export const Container = styled(Row)<Pick<PaginationFooterProps, 'fixed'>>`
  padding: ${({ fixed }) => (fixed ? '1.25rem 2.75rem' : '0')};
  position: ${({ fixed }) => (fixed ? 'fixed' : 'static')};
  bottom: 0;
  width: 100%;
  background: ${({ theme }) => `
    linear-gradient(to top, ${theme.color.paginationFooter.backgroundColor} 80%, transparent 20%);
  `};
  z-index: 5;
  flex-direction: column;
`;

export const Border = styled.div`
  margin-bottom: 0.9375rem;
  height: 0;
  border: 1px solid ${({ theme }) => hexToRgba(theme.color.paginationFooter.borderColor, 0.3)};
`;

export const Content = styled(Row)<Pick<PaginationFooterProps, 'showPageSizeSelector'>>`
  justify-content: ${({ showPageSizeSelector }) => (
    showPageSizeSelector
      ? 'space-between'
      : 'flex-end'
  )};
  width: 100%;
`;
